var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66362 33.3135L13.6035 34.4604C14.2575 34.5359 14.8382 34.9138 15.172 35.4812L17.8735 40.0738C18.7288 41.5278 20.8631 41.4297 21.5815 39.9033L23.5975 35.6192C23.9021 34.9718 24.5156 34.5243 25.225 34.4317L33.6755 33.3295C34.969 33.1608 35.7985 31.8645 35.3851 30.6273C31.8251 19.972 27.9347 13.2939 20.0217 3.16193C19.1688 2.0699 17.508 2.10658 16.7039 3.23496C9.86433 12.8324 6.20379 19.5035 1.95225 30.4988C1.46059 31.7703 2.30932 33.1572 3.66362 33.3135Z",
    stroke: "#6A6A6D",
    strokeWidth: 3.14815
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8397,
    cy: 21.9881,
    r: 3.67284,
    stroke: "#6A6A6D",
    strokeWidth: 3.14815
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.cec273fe6e06be994618bc17c9b6b0f5.svg";
export { ForwardRef as ReactComponent };